﻿const CONSTANTS = Object.freeze({
    CONTACT_URL: "https://walrus.lv/#form",
    ONE_FILE_SIZE_LIMIT: 1 * 1024 * 1024, // 1 MB in bytes (binary)
    TOTAL_UPLOAD_SIZE_LIMIT: 20 * 1024 * 1024, // 20 MB in bytes (binary)
    TOTAL_UPLOAD_COUNT_LIMIT: 20,
    API_URL_CURRENT_PLAN: "/api/payment/SubscriptionInfo",
    API_URL_PLANS: "/api/licenseplans",
    API_URL_PAYMENT_PROCESS: '/api/user-payments',
    API_URL_PURCHASE_SUBSCRIPTION: '/api/payment/ProcessPaymentLinkPaySubscription',
    API_URL_CANCEL_SUBSCRIPTION: '/api/payment/RequestCancelEveryPaySubscriptions',
    API_URL_EVERYPAY_CALLBACK: '/api/everypay/callback',
    cookies: '/login?useCookies=true',
    sessionCookies: '/login?useSessionCookies=true',
    loginFailed: 'Login failed. Please check your username and password.',
    generalError: 'Failed. An error has occurred'
});

export default CONSTANTS;